module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/04-41d3f6abcbff33125c923716626581b8.jpg";